import { ZonedDate } from '@eika-infrastruktur/date';
import { useQuery, QueryResult, useDispatchQuery } from '@eika-infrastruktur/react-query';

import { getBankingHolidays, getFirstBankingDay, getNextBankingDay } from '../services/bankingdaysService';

export const useFirstBankingDay = (fromDate?: ZonedDate, options = {}): QueryResult<ZonedDate | undefined> =>
    useQuery<ZonedDate | undefined>({
        queryKey: ['bankingdays', fromDate?.toDateString()],
        queryFn: () => getFirstBankingDay(fromDate!),
        enabled: !!fromDate,
        staleTime: Infinity,
        ...options,
    });

export const useFirstBankingDayDispatch = <A, T>(
    fromDate: ZonedDate | undefined,
    dispatch: (action: A) => void,
    type: T,
) => {
    return useDispatchQuery(useFirstBankingDay(fromDate), dispatch, type);
};

export const useNextBankingDay = (fromDate: ZonedDate | undefined): QueryResult<ZonedDate | undefined> =>
    useQuery<ZonedDate | undefined>({
        queryKey: ['nextBankingdays', fromDate?.toDateString()],
        queryFn: () => getNextBankingDay(fromDate!),
        enabled: !!fromDate,
        staleTime: Infinity,
    });

export const useNextBankingDayDispatch = <A, T>(
    fromDate: ZonedDate | undefined,
    dispatch: (action: A) => void,
    type: T,
) => {
    return useDispatchQuery(useNextBankingDay(fromDate), dispatch, type);
};

export const useBankingHolidays = (fromDate: ZonedDate, toDate: ZonedDate, options = {}): QueryResult<ZonedDate[]> =>
    useQuery({
        queryKey: ['bankingholidays', fromDate?.toDateString(), toDate?.toDateString()],
        queryFn: () => getBankingHolidays(fromDate, toDate),
        staleTime: Infinity,
        ...options,
    });
